module.exports = __webpack_public_path__ + "img/2d.e299b16a.png";